function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import LottieAnimationComponent from "../lottie-animtaion/lottie-animation-component";
import { StyledSignupWithAnimationComponent } from "./signup-with-animation-component.scss";
const LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-swirl-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {
        height: "100%"
    }
};
const FIRE_ACTION_FRAME = 27;
class SignupWithAnimationComponent extends PureComponent {
    bounceSignup() {
        if (this.state.animated) return;
        this.setState({
            animated: true
        }, ()=>{
            setTimeout(()=>{
                this.setState({
                    animated: false
                });
            }, 2000);
        });
    }
    render() {
        const { withAnimation, signupForm, direction } = this.props;
        return /*#__PURE__*/ _jsx(StyledSignupWithAnimationComponent, {
            className: classnames("signup-with-animation-component", {
                [direction]: direction
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "inline-flex-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("button-wrapper", {
                            "bounce-button": this.state.animated
                        }),
                        children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread({}, signupForm))
                    }),
                    withAnimation && /*#__PURE__*/ _jsx("div", {
                        className: "lottie-animation-wrapper",
                        children: /*#__PURE__*/ _jsx(LottieAnimationComponent, _object_spread({}, LOTTIE_ANIMATION_CONFIG))
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.bounceSignup = this.bounceSignup.bind(this);
        LOTTIE_ANIMATION_CONFIG.fireActionOnFrame = {
            frame: FIRE_ACTION_FRAME,
            action: this.bounceSignup
        };
        this.state = {
            animated: false
        };
    }
}
export { SignupWithAnimationComponent as default };
SignupWithAnimationComponent.defaultProps = {
    withAnimation: true
};
